export const getClickedFilterName = ({
  prevFilters,
  newFilters,
  filtersWithIds,
  key = 'text',
}) => {
  const clickedFilterId = newFilters.find((filter) => {
    return !prevFilters.includes(filter);
  });
  return filtersWithIds.find((filter) => filter.value === clickedFilterId)?.[
    key
  ];
};
